import { render, staticRenderFns } from "./AddTagsModal.vue?vue&type=template&id=28c50f72&"
import script from "./AddTagsModal.vue?vue&type=script&lang=js&"
export * from "./AddTagsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports